import React, { useEffect, useState } from 'react';
import { Button, Grid } from '@mui/material';
import APICaller, { MethodType } from '../common/APICaller';
import { useNavigate, useSearchParams } from 'react-router-dom';
import AssessmentGradingStatusCard from './AssessmentGradingStatusCard';
import { ApplicationStatus } from '../JobCard/JobStatusCard';

interface AssessmentGradingStatusCardsProps {
  jobId: string | undefined;
  applicantId: string | undefined;
}

interface AssessmentGradingStatus {
  id: number;
  title: string;
  isGraded: boolean;
  isComplete: boolean;
  isOptional?: boolean | number;
}

const AssessmentGradingStatusCards: React.FC<
  AssessmentGradingStatusCardsProps
> = ({ jobId, applicantId }) => {
  const [data, setData] = useState<AssessmentGradingStatus[]>([]);
  const [allRequiredCompleted, setAllRequiredCompleted] = useState<boolean>(false);
  const [allRequiredGraded, setAllRequiredGraded] = useState<boolean>(false);
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const isViewMode = searchParams.get('view') === 'true';
  console.log('AssessmentGradingStatusCards - isViewMode:', isViewMode, 'searchParams:', searchParams.toString());
  useEffect(() => {
    // TODO: change url
    APICaller(
      `/metrics/jobs/${jobId}/applicants/${applicantId}/assessments`,
      MethodType.GET,
    ).then(res => {
      console.log(res);
      if (res.errorMessage) {
        alert(res.errorMessage);
  } else if (res.assessments) {
    setData(res.assessments);
    const req = res.assessments.filter((a: any) => !a.isOptional);
    const reqCompleted = req.filter((a: any) => a.isComplete).length;
    const reqGraded = req.filter((a: any) => a.isGraded).length;
    setAllRequiredCompleted(req.length === 0 || reqCompleted === req.length);
    setAllRequiredGraded(req.length === 0 || reqGraded === req.length);
      }
    });
  }, [jobId, applicantId]);
  const finishGradingHandler = () => {
    APICaller(
      `/metrics/jobs/${jobId}/applicants/${applicantId}/status/update`,
      MethodType.PUT,
      {
        status: ApplicationStatus.PENDING_DECISION,
      },
    ).then(res => {
      if (res.errorMessage) {
        console.log(res.errorMessage);
      } else {
        navigate(`/manage-jobs/applicants/${jobId}`);
      }
    });
  };

  const GoBackButton = (
    <Button
      variant="outlined"
      sx={{
        width: '20%',
        backgroundColor: 'white',
        color: 'var(--ttg-black)',
        borderColor: 'var(--ttg-black)',
        '&:hover': {
          backgroundColor: '#f5f5f5',
          borderColor: 'var(--ttg-black)',
        },
        margin: '20px 5px 0 5px',
        padding: '10px 20px',
        cursor: 'pointer',
      }}
      onClick={() => {
        navigate(`/manage-jobs/applicants/${jobId}`);
      }}
    >
      Go Back
    </Button>
  );

  const SubmitButton = (
    <Button
      variant="contained"
      sx={{
        width: '30%',
        backgroundColor: 'var(--ttg-green)',
        '&:hover': {
          backgroundColor: 'var(--ttg-green)',
        },
      }}
      onClick={finishGradingHandler}
    >
      Finish Grading
    </Button>
  );

  return (
    <Grid container flexDirection={'column'} alignItems={'center'}>
      {data.map(d => {
        return (
          <AssessmentGradingStatusCard
            key={d.id}
            assessmentId={`${d.id}`}
            title={d.title}
            isGraded={d.isGraded}
            isComplete={d.isComplete}
            isOptional={d.isOptional}
            jobId={jobId}
            applicantId={applicantId}
          />
        );
      })}
  {/* In view mode, always show Go Back button. Otherwise, show Submit if all graded, Go Back if not */}
  {isViewMode ? GoBackButton : (allRequiredCompleted ? (allRequiredGraded ? SubmitButton : GoBackButton) : GoBackButton)}
    </Grid>
  );
};

export default AssessmentGradingStatusCards;
